/**
 * YUMO mikro animasyonlar — section reveal + kart girişleri.
 * Yalnızca transform/opacity; IntersectionObserver ile tek seferlik.
 * prefers-reduced-motion aktifse hiçbir şey yapılmaz (içerik anında görünür).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('yumo-motion');

  var GROUPS =
    '.yumo-hero__features, .yumo-discovery__grid, .yumo-how__steps, ' +
    '.yumo-why__grid, .yumo-parents__tips, .yumo-gallery__masonry, ' +
    '.yumo-product__bullets, .yumo-faq__list, .yumo-questions__list, .yumo-cta__features, ' +
    '.yumo-contents__items, .yumo-contents__tiles, .yumo-support__cards, .yumo-areas__grid';

  var SINGLES =
    '.yumo-section-head, .yumo-hero__content, .yumo-hero__stage, ' +
    '.yumo-about__stage, .yumo-about__content, .yumo-story__stage, .yumo-story__content, ' +
    '.yumo-statement__content, .yumo-statement__media, .yumo-questions__inner, .yumo-why__head, ' +
    '.yumo-contents__head, .yumo-contents__disclaimer, .yumo-contents__seans, .yumo-contents__closing, ' +
    '.yumo-method__intro, .yumo-method__diagram, .yumo-areas__head, ' +
    '.yumo-support__intro, .yumo-support__band, .yumo-support__closing, ' +
    '.yumo-product__gallery, .yumo-product__info, .yumo-social__inner, ' +
    '.yumo-founder__content, .yumo-cta__inner, .yumo-cta__final, .yumo-parents__panel, ' +
    '.yumo-showcase__carousel';

  var targets = [];

  document.querySelectorAll(GROUPS).forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.classList.add('yumo-reveal');
      /* Kademeli giriş: en fazla 6 adım, 70ms aralık */
      child.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
      targets.push(child);
    });
  });

  document.querySelectorAll(SINGLES).forEach(function (el) {
    el.classList.add('yumo-reveal');
    targets.push(el);
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('yumo-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });
})();
